import { render } from "./ExpendShow.vue?vue&type=template&id=24a78d35"
import script from "./ExpendShow.vue?vue&type=script&lang=js"
export * from "./ExpendShow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__